import { render, staticRenderFns } from "./ModalEditStudent.vue?vue&type=template&id=05dd81cf&scoped=true"
import script from "./ModalEditStudent.vue?vue&type=script&lang=js"
export * from "./ModalEditStudent.vue?vue&type=script&lang=js"
import style0 from "./ModalEditStudent.vue?vue&type=style&index=0&id=05dd81cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd81cf",
  null
  
)

export default component.exports